module.exports = __webpack_public_path__ + "static/media/sud_america_motociclismo_1.312b2106.jpg";